// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__26wTs","colBig":"styles_colBig__3Exhc","colSmall":"styles_colSmall__11Egf"};